var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "#E5F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5005 9.49565C17.1491 11.4902 16.8283 13.4808 17 15.5C17.0747 16.3778 17.6057 17.7183 18 18.5C18.3943 19.2812 19.1558 19.8726 20 20C21.0016 20.1522 21.3892 19.9723 22 21C22.3019 21.5082 21.9314 22.4548 21.4283 22.7479C20.8278 23.0983 20.1562 22.9952 19.5015 22.9513C18.4464 22.8804 17.2265 22.9653 16.2185 22.5953C15.4126 22.2994 14.8242 21.5887 14.3253 20.8714C13.8274 20.1546 13.363 19.3837 12.67 18.8662C12.0746 18.4205 11.3965 18.2814 10.7511 17.9543C9.84487 17.4942 8.67402 16.6234 9.08515 15.4273C9.24755 14.9551 10.6743 13.371 11 13C12.3155 11.5034 12.2575 10.7892 13.1605 9",
    stroke: "#07133F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.d13cb4e42747f0e027b621092ea907c4.svg";
export { ForwardRef as ReactComponent };